import { useEffect, useRef } from "react";

export default function useInfiniteScroll({
  enabled,
  hasMore,
  onLoadMore,
  rootMargin = "100px",
  threshold = 0.1,
}) {
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        if (!hasMore) return;
        if (loadingRef.current) return;

        loadingRef.current = true;
        onLoadMore?.();
      },
      { root: null, rootMargin, threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled, hasMore, onLoadMore, rootMargin, threshold]);

  const resetLoading = () => {
    loadingRef.current = false;
  };

  return { sentinelRef, resetLoading };
}